import { HugeiconsIcon } from "@hugeicons/react";
import {
  Cancel01Icon,
  InformationCircleIcon,
} from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";
import { cn } from "../../utils";
import { Button } from "../button";
import computeVariantStyle, {
  type GameRtpListVariant,
} from "./computeVariantStyle";

type Props = {
  title: string;
  variant: GameRtpListVariant;
  hasInfo?: boolean;
  isInfoOpen?: boolean;
  translations?: Record<string, string>;
  onInfoClick?: () => void;
};

const GameRtpListHeader: FC<Props> = ({
  title,
  variant,
  hasInfo = false,
  isInfoOpen = false,
  translations,
  onInfoClick,
}) => {
  const { bg } = computeVariantStyle(variant);
  const infoLabel =
    translations?.["game_rtp_list.info_label"] ?? "More information";
  const closeLabel = translations?.["game_rtp_list.close_label"] ?? "Close";

  return (
    <div
      data-slot="game-rtp-list-header"
      className={cn(
        "flex items-center gap-2 rounded-t-3xl px-4 py-3 text-white",
        bg,
      )}
    >
      <p className="font-semibold">
        {variant === "cold" ? "❄️" : "🔥"} {title}
      </p>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className={cn(
          "ml-auto bg-black/20 text-white hover:bg-black/30",
          !hasInfo && "invisible",
        )}
        aria-label={isInfoOpen ? closeLabel : infoLabel}
        aria-hidden={!hasInfo}
        tabIndex={hasInfo ? undefined : -1}
        onClick={onInfoClick}
      >
        <HugeiconsIcon
          icon={isInfoOpen ? Cancel01Icon : InformationCircleIcon}
        />
      </Button>
    </div>
  );
};

export default GameRtpListHeader;
